import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'

export default {
  // query
  getAllChannel: params => {
    const query = gql`
      query($in: ChannelFilterInput!) {
        allChannel(in: $in) {
          data {
            id
            name
            section {
              id
              name
            }
            creator {
              id
              username
            }
            updater {
              id
              username
            }
            created_at
            updated_at
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },
  // mutation
  createChannel: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateChannelInput!) {
        createChannel(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  }
}
